export default __webpack_public_path__ + "static/media/one-week-sprint.b3fc78bf.svg";